// extracted by mini-css-extract-plugin
export var active = "menu-module--active--O3tgs";
export var activeRoundBorder = "menu-module--activeRoundBorder--3O7nz";
export var group = "menu-module--group--U0wEH";
export var icon = "menu-module--icon--+LxoJ";
export var iconWrapper = "menu-module--iconWrapper--T5MEF";
export var link = "menu-module--link--CT4wI";
export var menuItem = "menu-module--menuItem--B-Ytj";
export var root = "menu-module--root---5JWB";